import {
    Button, HStack, Modal, ModalBody, ModalCloseButton, ModalContent,
    ModalFooter, ModalHeader, ModalOverlay, useDisclosure, Text, useToast
} from '@chakra-ui/react'
import { useEffect, useRef } from 'react'
import { BsTrash, BsX } from 'react-icons/bs'
import { deleteEmail } from '../../classes/Email'
import { AL_DELETE, defaultSelectData, reload, useSelectedItemAlertContext } from '../../context/selectedItemAlertContext'
import { useUserContext } from '../../context/userContext'
import { toastErrDesc, toastVal } from '../../utils/toastUtils'

const ModalEmailDelete = ({ data }) => {
    const { onClose, isOpen, onOpen } = useDisclosure()
    const { userData } = useUserContext()
    const { setItemData } = useSelectedItemAlertContext()
    const toast = useToast()

    const openModal = useRef()
    openModal.current = () => {
        if (data?.type === AL_DELETE) onOpen()
    }

    useEffect(() => {
        openModal.current()
    }, [data])

    const onCloseHandle = () => {
        setItemData(defaultSelectData)
        onClose()
    }

    const onDeleteHandle = async () => {
        if (data?.id) {
            await deleteEmail(data?.id, userData.token)
                .then(res => {
                    toast(toastVal({
                        title: "การลบข้อมูลสำเร็จ",
                        description: `ลบข้อมูล เรียบร้อยแล้ว`,
                    }))
                    setItemData((prev) => reload(prev))
                    onCloseHandle()
                })
                .catch(error => {
                    toast(toastVal({
                        title: "การลบข้อมูล ไม่สำเร็จ",
                        description: toastErrDesc(error),
                        status: "error",
                    }))
                })
        } else {
            toast(toastVal({
                title: "การลบข้อมูล ไม่สำเร็จ",
                description: "ไม่พบข้อมูลที่ต้องการจะลบ",
                status: "error",
            }))
        }
    }

    return (
        <Modal isOpen={isOpen} onClose={onCloseHandle} motionPreset="slideInBottom">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>ลบข้อมูลรูปแบบอีเมล</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Text>ต้องการลบข้อมูลรูปแบบอีเมล นี้หรือไม่</Text>
                </ModalBody>
                <ModalFooter>
                    <HStack w="full" justify="center" pb={3}>
                        <Button leftIcon={<BsTrash />} colorScheme="red" onClick={onDeleteHandle}>
                            ลบข้อมูล
                        </Button>
                        <Button leftIcon={<BsX />} colorScheme="gray" onClick={onCloseHandle}>
                            ยกเลิก
                        </Button>
                    </HStack>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default ModalEmailDelete
